import { ListCanvasLayer } from "../canvaslayer";
import { EndpointIcon } from "./endpointIcon";
export class EndpointRecord {
    constructor(id, latitude, longitude, state = -1) {
        this.id = id;
        this.latitude = latitude;
        this.longitude = longitude;
        this.state = state;
    }
    get x() {
        return this.longitude;
    }
    get y() {
        return this.latitude;
    }
}
export class EndpointLayer extends ListCanvasLayer {
    constructor() {
        super(...arguments);
        this.iconTemplate = new EndpointIcon({
            colour: "red",
            size: 5,
            fill: true,
        });
        this.serial = -1;
        this.generation = -1;
    }
    setStyle(style) {
        this.iconTemplate.setStyle(style);
    }
    addEndpoints(load_data) {
        let meters = load_data.data.map(([id, lat, lon, state]) => {
            return new EndpointRecord(id, lat, lon, state);
        });
        this.setData(meters);
        this.generation = load_data.generation;
        this.serial = load_data.serial;
        this.redraw();
    }
    renderItem(record) {
        return this.renderEndpointWithStyle(record, this.iconTemplate);
    }
    renderEndpointWithStyle(record, icon) {
        if (record.state < 0) {
            return;
        }
        const ctx = this.getCanvas().getContext("2d");
        if (!ctx) {
            return;
        }
        let dot = this.transform_latlon([
            record.latitude,
            record.longitude,
        ]).subtract([icon.style.size, icon.style.size]);
        ctx.drawImage(icon.canvas, ~~dot.x, ~~dot.y);
    }
}
